module.exports = __webpack_public_path__ + "img/loginappcode.2de082f5.png";